// Backup & Restore — data-testid registry.
export const BACKUP = {
  navBackup: "nav-backup",
  createBtn: "backup-create-btn",
  includeFiles: "backup-include-files",
  remarks: "backup-remarks",
  submit: "backup-create-submit",
  refresh: "backup-refresh",
  table: "backup-table",
  row: (id) => `backup-row-${id}`,
  download: (id) => `backup-download-${id}`,
  restore: (id) => `backup-restore-${id}`,
  restoreConfirm: "backup-restore-confirm",
  restoreConfirmText: "backup-restore-confirm-text",
};
